import Certify1 from "@/assets/certificationsRouter/certificationsFile/112/Computer Knowledge Today_1120606.pdf";
import Certify2 from "@/assets/certificationsRouter/certificationsFile/112/Professional VocabularyQuotient Credential- AI LiteracySpecialist_1120604.jpg";
import Certify3 from "@/assets/certificationsRouter/certificationsFile/112/Artificial Intelligence LiteracyCertification Programs_23-A-AIL-00-SP-886000806_1120604.pdf";
import Certify4 from "@/assets/certificationsRouter/certificationsFile/112/Disaster Risk Montioring UsingSatellite Imagery_1120128.pdf";
import Certify5 from "@/assets/certificationsRouter/certificationsFile/112/Statistical Knowledge Today_1120707.pdf";

var certifications_112 = [
  Certify1,
  Certify2,
  Certify3,
  Certify4,
  Certify5,
  // Certify6,
  // Certify7,
  // Certify8,
  // Certify9,
  // Certify10,
  // Certify11,
  // Certify12,
  // Certify13,
  // Certify14,
  // Certify15,
  // Certify16,
  // Certify17,
  // Certify18,
  // Certify19,
  // Certify20,
  // Certify21,
  // Certify22,
  // Certify23,
  // Certify24,
  // Certify25,
  // Certify26,
  // Certify27,
  // Certify28,
  // Certify29,
  // Certify30,
  // Certify31,
  // Certify32,
  // Certify33,
  // Certify34,
  // Certify35,
  // Certify36,
  // Certify37,
  // Certify38,
  // Certify39,
  // Certify40,
  // Certify41,
  // Certify42,
  // Certify43,
  // Certify44,
  // Certify45,
  // Certify46,
  // Certify47,
  // Certify48,
  // Certify49,
  // Certify50,
  // Certify51,
  // Certify52,
  // Certify53,
  // Certify54,
  // Certify55,
  // Certify56,
  // Certify57,
  // Certify58,
  // Certify59,
  // Certify60,
  // Certify61,
  // Certify62,
  // Certify63,
  // Certify64,
  // Certify65,
  // Certify66,
  // Certify67,
  // Certify68,
  // Certify69,
  // Certify70,
  // Certify71,
  // Certify72,
  // Certify73,
  // Certify74,
  // Certify75,
  // Certify76,
  // Certify77,
  // Certify78,
  // Certify79,
  // Certify80,
  // Certify81,
  // Certify82,
  // Certify83,
  // Certify84,
  // Certify85,
  // Certify86,
  // Certify87,
  // Certify88,
  // Certify89,
  // Certify90,
  // Certify91,
  // Certify92,
  // Certify93,
  // Certify94,
  // Certify95,
  // Certify96,
  // Certify97,
  // Certify98,
  // Certify99,
  // Certify100,
  // Certify101,
  // Certify102,
  // Certify103,
  // Certify104,
  // Certify105,
  // Certify106,
  // Certify107,
  // Certify108,
  // Certify109,
  // Certify110,
  // Certify111,
  // Certify112,
  // Certify113,
  // Certify114,
  // Certify115,
  // Certify116,
  // Certify117,
  // Certify118,
  // Certify119,
  // Certify120,
  // Certify121,
  // Certify122,
  // Certify123,
  // Certify124,
  // Certify125,
  // Certify126,
  // Certify127,
  // Certify128,
  // Certify129,
  // Certify130,
  // Certify131,
  // Certify132,
  // Certify133,
  // Certify134,
  // Certify135,
  // Certify136,
  // Certify137,
  // Certify138,
  // Certify139,
  // Certify140,
  // Certify141,
  // Certify142,
  // Certify143,
  // Certify144,
  // Certify145,
  // Certify146,
  // Certify147,
  // Certify148,
];
export { certifications_112 };
